import * as React from "react"

import { toast } from "../components/Toast/useToast"

const COPY_FEEDBACK_MS = 1500

export function useCopyToClipboardFeedback(
  feedbackMs: number = COPY_FEEDBACK_MS,
) {
  const [copied, setCopied] = React.useState(false)
  const timeoutRef = React.useRef<ReturnType<typeof setTimeout> | null>(null)

  React.useEffect(
    () => () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    },
    [],
  )

  const copy = React.useCallback(
    async (value: string): Promise<boolean> => {
      try {
        await navigator.clipboard.writeText(value)
        setCopied(true)
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current)
        }
        timeoutRef.current = setTimeout(() => setCopied(false), feedbackMs)
        return true
      } catch (error) {
        setCopied(false)
        toast.error({
          error,
          title: "Couldn't copy",
          fallback: "Failed to copy to clipboard.",
        })
        return false
      }
    },
    [feedbackMs],
  )

  return { copied, copy } as const
}
